<template>
  <div class="card card-shadow ml-2 mr-2 ml-md-0 mr-md-0" :class="color_by_provider">
    <div class="card-header">
      <div class="row">
        <div class="col-md h6">
          <b>{{ entityName }}</b>
        </div>

        <div class="col-md">
          <div class="description">
            {{ $t('table.headers.offer_begin_datetime') }}
          </div>
          <b>{{ startAt | formatDateAtTimeList }}</b>
        </div>

        <div class="col-md">
          <div class="description">
            {{ $t('table.headers.offer_end_datetime') }}
          </div>
          <b>{{ endAt | formatDateAtTimeList }}</b>
        </div>

        <div class="col-md">
          <div class="btn-toolbar flex-wrap justify-content-end">
            <div v-if="actionCondition" class="btn-group">
              <router-link :to="{ name: 'AdminOffer', params: { id: offer.id }}" class="btn btn-icon">
                <i class="fa fa-eye"></i>
              </router-link>
            </div>

            <div v-if="contractEditionButton"
                 href="#select"
                 class="btn btn-icon"
                 @click.prevent="selectContract">
              <i class="fa fa-check text-green" v-if="hasContract"></i>
              <i class="fa fa-edit" v-else></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showDetails">
      <div class="card-body">
        <div class="row">
          <div class="col-md mt-3 mb-3 mt-md-0 mb-md-0">
            <div class="description">{{ $t('table.headers.services') }} </div>
            <services-with-hub v-if="hub" :hub="hub" :servicesNames="replacedService" />
            <b v-else>{{ replacedService }}</b>
          </div>

          <div class="col-md mb-3 mb-md-0">
            <div class="description">{{ $t('table.headers.occupation') }} </div>
            <b>{{ replacedOccupation }}</b>
          </div>
        </div>
      </div>

      <div class="card-footer text-muted">
        <div class="row">
          <div class="col text-right">
            <div class="description">{{ $t('table.headers.published_at') }}</div>
            <b>{{ publishedAt | formatDateAtTime }}</b>

            <div class="description">{{ $t('table.headers.by') }}</div>
            <b>{{ authorName }}</b>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getContractTemplatesByEntityId } from '@/helpers/contracts'
import SelectContractForm from '@/components/offers/SelectContractForm'
import ServicesWithHub from '@/components/hubs/ServicesWithHub'
import offers_mixin from '@/mixin/offers'
import { checkCanEditContract } from '@/helpers/contracts'

const SELECT_CONTRACT_VIEW_NAME = 'SelectContractForm'

export default {
  name: 'CandidatePlanningTableRow',
  props: ['unavailabilityDate', 'showHub'],
  mixins: [offers_mixin],
  components: {
    ServicesWithHub
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser'
    }),
    provider() {
      return this.unavailabilityDate.provider
    },
    offer() {
      return this.unavailabilityDate.offer
    },
    color_by_provider() {
      if (this.provider == "offer") {
        return "card-offer-border-color"
      } else if (this.provider == "personal") {
        return "card-personal-border-color"
      }
      return "card-imported-border-color"
    },
    entityName() {
      if (this.provider == 'TsPlanner') {
        return this.unavailabilityDate.entity_name
      } else if (this.provider == "offer" && this.offer) {
        return this.offer.entity.name
      }

      return this.$i18n.t('CandidatePlanning.unavailable')
    },
    replacedOccupation() {
      return this.offer ? this.offer.replaced_occupation.name : ""
    },
    hub() {
      if(this.offer &&
         this.offer.entity &&
         this.offer.entity.hubs &&
         this.offer.entity.hubs.filter((hub) => !hub.is_fake).length > 0 &&
         this.isManagedEntity() &&
         this.offer.hub &&
         this.offer.hub.name) {
        return { name: this.offer.hub.name };
      }

      return null;
    },
    replacedService() {
      return this.offer ? this.offer.replaced_service.name : ""
    },
    startAt() {
      return this.offer ? this.offer.start_at : this.unavailabilityDate.start_at
    },
    endAt() {
      return this.offer ? this.offer.end_at : this.unavailabilityDate.end_at
    },
    publishedAt() {
      return this.offer ? this.offer.published_at : ""
    },
    authorName() {
      return this.offer ? `${this.offer.author.first_name} ${this.offer.author.last_name}` : ""
    },
    actionCondition() {
      if (!this.offer) {
        return false;
      }
      return (this.currentUser.services.map(service => service.id).includes(this.offer.replaced_service.id));
    },
    contractEditionButton(){
      if(this.contractEdition()) {
        if (this.offer.applied_candidates[0].user_info.resource_type == 'extern') {
          this.$emit('showContractColumn', this.actionCondition)
          return this.actionCondition
        }
      }
      return false
    },
    hasContract() {
      return this.offer.contract !== null;
    },
    showDetails() {
      return this.offer && this.isManagedEntity();
    }
  },
  methods: {
    isManagedEntity: function() {
      return this.currentUser.entities.some(entity => entity.id == this.offerEntity().id);
    },
    offerEntity: function() {
      return this.offer.entity
    },
    selectContract() {
      if (this.hasContract) {
        this.$router.push({
          name: 'Contract',
          params: { id: this.offer.contract.id }
        });
      } else {
        this.$dialog.alert("select contract", {
          view: SELECT_CONTRACT_VIEW_NAME,
          html: true,
          animation: 'fade',
          backdropClose: true,
          contractTemplates: this.contractTemplatesForOffer()
        })
        .then(dialog => {
          this.$router.push({ name: 'OfferContract', params: {id: this.offer.id, contract_id: dialog.data}});
        });
      }
    },
    contractTemplatesForOffer() {
      return getContractTemplatesByEntityId({
        entityId: this.offer.entity.id,
        templates: this.contractTemplates
      })
    },
    contractEdition() {
      let offer = this.offer
      if (offer) {
        return this.isManager &&
          offer.status == "validated" &&
          checkCanEditContract(this.currentUser, this.offer.entity.id) &&
          offer.applied_candidates != undefined;
      }
      return false
    },
    loadDialogSelectContractForm() {
      this.$dialog.registerComponent(SELECT_CONTRACT_VIEW_NAME, SelectContractForm);
    },
    initTab: function(){
    }
  },
  mounted: function() {
    this.loadDialogSelectContractForm()
    this.reloadContractTemplates()
  }
}
</script>

<style scoped>
  .card-footer .col div {
    display: inline-block;
  }
  .card-footer {
    background: none;
    border-top: none;
    padding-top: 0;
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/users/CandidatePlanningTableRow.vue